import Header from '@components/Comman/Header'
import React, { useState } from 'react'
import FAQ from './FAQ'
import PageTitle from '@components/Comman/PageTitle'
import { Modal } from 'antd'
import AddTicket from './AddTicket'
import './index.css'

const Help = () => {
    const [open, setOpen] = useState(false);

    const handleSubmit = () => {
        setOpen(false)
      };
    
      const handleCancel = () => {
        setOpen(false);
      };

    return (
        <div>
            <Header pagTitle="Help" />
            <div className="contentBody">
                <div className="bodycard">
                    <PageTitle buttonClick={()=> setOpen(!open)} buttonLabel='Add Ticket' pagTitle="Frequently Asked Questions" button={true} buttonLink={''} />
                    <FAQ />
                </div>
            </div>
            <Modal
                open={open}
                title={<span style={{ fontSize: '20px' }}>Add your ticket for support</span>}
                onOk={() => setOpen(false)}
                className='help-modal'
                maskClosable={false} // Add this prop
                onCancel={handleCancel}
                footer={false}
            >
                <AddTicket handleCancel={()=> setOpen(!open) } handleSubmit={handleSubmit} />
            </Modal>
        </div>
    )
}

export default Help